/** Impl dos use cases leitura + workflow admin de SolicitacaoConclusao. @since G.5.11 (estendido G.5.12) */
import type { Page } from '@/domain/model/Page';
import type {
  SolicitacaoConclusao, SolicitacaoConclusaoEtapa,
  SolicitacaoConclusaoDocumento, SolicitacaoConclusaoHistorico,
  DecidirEtapaCommand, PedirComplementacaoCommand,
  RegistrarAcademicoCommand, ReverterCommand,
} from '@/domain/model/SolicitacaoConclusao';
import type {
  SolicitacaoConclusaoGateway, ListSolicitacoesConclusaoParams,
  FilaSolicitacaoConclusaoParams,
} from '@/application/port/out/SolicitacaoConclusaoGateway';
import type {
  ListSolicitacoesConclusaoUseCase, GetSolicitacaoConclusaoUseCase,
  ListEtapasSolicitacaoConclusaoUseCase, ListDocumentosSolicitacaoConclusaoUseCase,
  ListHistoricoSolicitacaoConclusaoUseCase,
  FilaSolicitacaoConclusaoUseCase, ClaimEtapaSolicitacaoConclusaoUseCase,
  DecidirEtapaSolicitacaoConclusaoUseCase, PedirComplementacaoSolicitacaoConclusaoUseCase,
  RegistrarAcademicoSolicitacaoConclusaoUseCase, ReenviarSolicitacaoConclusaoUseCase,
  ReverterSolicitacaoConclusaoUseCase,
} from '@/application/port/in/SolicitacaoConclusaoUseCase';

export class ListSolicitacoesConclusao implements ListSolicitacoesConclusaoUseCase {
  constructor(private readonly g: SolicitacaoConclusaoGateway) {}
  execute(params: ListSolicitacoesConclusaoParams): Promise<Page<SolicitacaoConclusao>> { return this.g.list(params); }
}
export class GetSolicitacaoConclusao implements GetSolicitacaoConclusaoUseCase {
  constructor(private readonly g: SolicitacaoConclusaoGateway) {}
  execute(id: string): Promise<SolicitacaoConclusao> { return this.g.get(id); }
}
export class ListEtapasSolicitacaoConclusao implements ListEtapasSolicitacaoConclusaoUseCase {
  constructor(private readonly g: SolicitacaoConclusaoGateway) {}
  execute(id: string): Promise<SolicitacaoConclusaoEtapa[]> { return this.g.listEtapas(id); }
}
export class ListDocumentosSolicitacaoConclusao implements ListDocumentosSolicitacaoConclusaoUseCase {
  constructor(private readonly g: SolicitacaoConclusaoGateway) {}
  execute(id: string): Promise<SolicitacaoConclusaoDocumento[]> { return this.g.listDocumentos(id); }
}
export class ListHistoricoSolicitacaoConclusao implements ListHistoricoSolicitacaoConclusaoUseCase {
  constructor(private readonly g: SolicitacaoConclusaoGateway) {}
  execute(id: string): Promise<SolicitacaoConclusaoHistorico[]> { return this.g.listHistorico(id); }
}

// Workflow G.5.12
export class FilaSolicitacaoConclusao implements FilaSolicitacaoConclusaoUseCase {
  constructor(private readonly g: SolicitacaoConclusaoGateway) {}
  execute(params: FilaSolicitacaoConclusaoParams): Promise<Page<SolicitacaoConclusaoEtapa>> { return this.g.fila(params); }
}
export class ClaimEtapaSolicitacaoConclusao implements ClaimEtapaSolicitacaoConclusaoUseCase {
  constructor(private readonly g: SolicitacaoConclusaoGateway) {}
  execute(etapaId: string): Promise<SolicitacaoConclusaoEtapa> { return this.g.claimEtapa(etapaId); }
}
export class DecidirEtapaSolicitacaoConclusao implements DecidirEtapaSolicitacaoConclusaoUseCase {
  constructor(private readonly g: SolicitacaoConclusaoGateway) {}
  execute(etapaId: string, cmd: DecidirEtapaCommand): Promise<SolicitacaoConclusao> { return this.g.decidirEtapa(etapaId, cmd); }
}
export class PedirComplementacaoSolicitacaoConclusao implements PedirComplementacaoSolicitacaoConclusaoUseCase {
  constructor(private readonly g: SolicitacaoConclusaoGateway) {}
  execute(id: string, cmd: PedirComplementacaoCommand): Promise<SolicitacaoConclusao> { return this.g.pedirComplementacao(id, cmd); }
}
export class RegistrarAcademicoSolicitacaoConclusao implements RegistrarAcademicoSolicitacaoConclusaoUseCase {
  constructor(private readonly g: SolicitacaoConclusaoGateway) {}
  execute(etapaId: string, cmd: RegistrarAcademicoCommand): Promise<SolicitacaoConclusao> { return this.g.registrarAcademico(etapaId, cmd); }
}
export class ReenviarSolicitacaoConclusao implements ReenviarSolicitacaoConclusaoUseCase {
  constructor(private readonly g: SolicitacaoConclusaoGateway) {}
  execute(id: string): Promise<SolicitacaoConclusao> { return this.g.reenviar(id); }
}
export class ReverterSolicitacaoConclusao implements ReverterSolicitacaoConclusaoUseCase {
  constructor(private readonly g: SolicitacaoConclusaoGateway) {}
  execute(id: string, cmd: ReverterCommand): Promise<SolicitacaoConclusao> { return this.g.reverter(id, cmd); }
}
